// Public legal pages on the marketing site. One place, so every surface links
// to the same pages. The Terms and the Privacy Policy each have a section
// written for independent students (student-self-signup-prd.md §19); the
// STUDENT_* links open that section directly.
//
// Built on `marketingHref`, so a local build links to the local marketing dev
// server (or `VITE_MARKETING_URL`) and never falls back to production.

import { marketingHref } from './marketing';

export const TERMS_URL = marketingHref('/terms');
export const PRIVACY_URL = marketingHref('/privacy');

/** Terms §3A "Student accounts". The anchor is the heading slug on the marketing site. */
export const STUDENT_TERMS_URL = marketingHref('/terms#3a-student-accounts');

/** Privacy Policy §2A "If you are a student with your own account". */
export const STUDENT_PRIVACY_URL = marketingHref(
  '/privacy#2a-if-you-are-a-student-with-your-own-account',
);

/**
 * The one address a student uses for every privacy request (see, fix or delete
 * their data, withdraw Challenge media consent). The same address is in the
 * Student Terms, the student privacy notice and the student Challenge forms.
 */
export const STUDENT_PRIVACY_EMAIL = 'privacy@airbotix.ai';
